import React, { useEffect, useState } from 'react';
import './home.scss';
import NewsTopicLayout from '../../components/layout/mainNewsTopics/NewsTopicLayout';
import { TopicContent } from '../../components/category/TocpicContent/TopicContent';
import TodayNews from '../../components/mainNews/righItem/TodayNews';
import { PodTextS40W400Lh40 } from '../../components/texts/fontText/podkova/TextPodkova';
import Content1075Img from '../../components/contents/includeImg/1075/Content1075Img';
import ShowListBtn from '../../components/buttons/showList/ShowListBtn';
import Content565 from '../../components/contents/noImg/565/Content565';
import SubscribeBtn from '../../components/buttons/subscribe/SubscribeBtn';

import { axiosAuth } from '../../api/api';
import ImageSlider from '../../components/imageSlider/ImageSlider';
import { ICategoryNews, IContent, INewsItem, IUpdteTodayNews } from '../../tpyes/comment';
import { useNavigate } from 'react-router';

const Home = () => {
  const [mainNews, setMainNews] = useState<IContent[]>();
  const [topics, setTopics] = useState<IContent[]>();
  const [tredingIssues, setTredingIssues] = useState<IContent[]>();
  const [todayNews, setTodayNews] = useState<IUpdteTodayNews[]>();
  const [business, setBusiness] = useState<INewsItem[]>();
  const [economies, setEconomies] = useState<INewsItem[]>();
  const [cultures, setCultures] = useState<INewsItem[]>();
  const [esges, setEsges] = useState<INewsItem[]>();
  const [politicies, setPoliticies] = useState<INewsItem[]>();
  const [businessMainImg, setBusinessMainImg] = useState<string>();
  const [economiesMainImg, setEconomiesMainImg] = useState<string>();
  const [culturesMainImg, setCulturesMainImg] = useState<string>();
  const [esgesMainImg, setEsgesMainImg] = useState<string>();
  const [politiciesMainImg, setPoliticiesMainImg] = useState<string>();

  const navigate = useNavigate();
  const [responsive, setResponsive] = useState('');

  useEffect(() => {
    getCategories();
    getHotIssues();
    getTopStoriesNews();
    getTrendingNews();
    getUpdatesTodayNews();
  }, []);

  const getCategories = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news-category/');
      const dataList = response.data;

      dataList.map((item: ICategoryNews) => {
        const main_image = item?.latest_news?.category?.main_image;
        if (item?.name === 'Business') {
          getBusinessNews(item?.id);

          if (main_image) {
            setBusinessMainImg(main_image);
          }
        } else if (item?.name === 'Economy') {
          getEconomyNews(item?.id);
          if (main_image) {
            setEconomiesMainImg(main_image);
          }
        } else if (item?.name === 'Culture') {
          getCultureNews(item?.id);
          if (main_image) {
            setCulturesMainImg(main_image);
          }
        } else if (item?.name === 'ESG') {
          getEsgNews(item?.id);
          if (main_image) {
            setEsgesMainImg(main_image);
          }
        } else if (item?.name === 'Politics') {
          getPoliticsNews(item?.id);
          if (main_image) {
            setPoliticiesMainImg(main_image);
          }
        }
      });
    } catch (error) {
      error;

      return null;
    }
  };

  // 최신중에서 조회수 내림차순 (3일간 존재하는 것 중에서)
  const getHotIssues = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news/?ordering=-views,-published_at,&is_published=true&limit=5');
      const dataList = response.data.results;

      setMainNews(dataList);
    } catch (error) {
      error;

      return null;
    }
  };

  // isTop , 최신
  const getTopStoriesNews = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news/?is_top=true&limit=5&ordering=-published_at&is_published=true');
      const dataList = response.data.results;
      setTopics(dataList);
    } catch (error) {
      error;

      return null;
    }
  };

  // 최신 순
  const getTrendingNews = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news/?limit=5&ordering=-published_at&is_published=true');
      const dataList = response.data.results;
      setTredingIssues(dataList);
    } catch (error) {
      error;
    }
  };

  // 각 카테고리 별로 최신순
  const getUpdatesTodayNews = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news-category/?is_published=true');
      const dataList = response.data;
      setTodayNews(dataList);
    } catch (error) {
      error;
    }
  };

  // 각각 최신 순
  const getBusinessNews = async (id: number) => {
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${id}&ordering=-published_at&limit=6&is_published=true`);
      const { results } = response.data;
      setBusiness(results);
    } catch (error) {
      error;
    }
  };

  const getEconomyNews = async (id: number) => {
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${id}&ordering=-published_at&limit=5&is_published=true`);
      const { results } = response.data;
      setEconomies(results);
    } catch (error) {
      error;
    }
  };

  const getCultureNews = async (id: number) => {
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${id}&ordering=-published_at&limit=5&is_published=true`);
      const { results } = response.data;
      setCultures(results);
    } catch (error) {
      error;
    }
  };

  const getPoliticsNews = async (id: number) => {
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${id}&ordering=-published_at&limit=5&is_published=true`);
      const { results } = response.data;
      setPoliticies(results);
    } catch (error) {
      error;
    }
  };

  const getEsgNews = async (id: number) => {
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${id}&ordering=-published_at&limit=5&is_published=true`);
      const { results } = response.data;
      setEsges(results);
    } catch (error) {
      error;
    }
  };

  const handleResize = () => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
  };

  useEffect(() => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
    window.addEventListener('resize', handleResize);
    return () => {
      // cleanup
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="home">
      {responsive === 'desktop' && <img src="/seamansclub-news/assets/svg/top-banner.svg" alt="" className="icon" id="icon" />}
      <div className="main-title-mb"></div>
      <div className="main-container">
        <div className="both-side-layout">
          <div className="main-left">
            <div className="title">Hot Issues News</div>
            {mainNews && <ImageSlider newsData={mainNews} />}
            <div className="partition"></div>
            <div className="mt-30"></div>
            <div className="title">Top Stories News</div>
            {topics && <ImageSlider newsData={topics} />}
            <div className="partition"></div>
            <div className="mt-30"></div>
            <div className="title">Trending News</div>
            {tredingIssues && <ImageSlider newsData={tredingIssues} />}
          </div>

          {window?.innerWidth <= 768 ? (
            <>
              <div className="res-mt-140"></div>
              <div className="border-bottom-gray"></div>
              <div className="res-mb-140"></div>
            </>
          ) : null}

          <div className="main-right">
            <div className="main-right-text-container">
              <PodTextS40W400Lh40 text="Updates Today News" />
            </div>
            <div className="item-container">
              {todayNews?.map((item: IUpdteTodayNews, index: number) => {
                return <TodayNews key={index} news={item} />;
              })}
            </div>
          </div>
        </div>

        <SubscribeBtn />

        <NewsTopicLayout border={false} classNameContainer={window.innerWidth >= 768 ? 'border-bottom' : ''} page="home">
          <div className="topic-layout-container">
            <div className="topic-left">
              <div className="topic-business">
                <TopicContent contentText={'BUSINESS'} type="business" mainImg={businessMainImg} />
                <div className="topic-container flex fd-col">
                  {business?.map((item: INewsItem, index: number) => {
                    const isLastItem = index === business.length - 1;
                    return <Content1075Img key={index} noBorder={isLastItem} {...item} />;
                  })}

                  <div className="flex jc-center">
                    <ShowListBtn
                      addList={() => {
                        navigate('/newsTopic/1');
                      }}
                    />
                  </div>
                  <div className="line"></div>
                </div>
              </div>

              <div className="topic-economy">
                <TopicContent contentText={'ECONOMY'} type="economy" mainImg={economiesMainImg} />
                <div className="topic-container flex fd-col">
                  {economies?.map((item: INewsItem, index: number) => {
                    const isLastItem = index === economies.length - 1;
                    return <Content1075Img key={index} {...item} noBorder={isLastItem} />;
                  })}
                  <div className="flex jc-center">
                    <ShowListBtn
                      addList={() => {
                        navigate('/newsTopic/4');
                      }}
                    />
                  </div>
                  <div className="line"></div>
                </div>
              </div>
            </div>
            <div className="topic-right">
              <div className="topic-politics">
                <TopicContent contentText={'POLITICS'} type="politics" mainImg={politiciesMainImg} />
                <div className="topic-container flex fd-col">
                  {politicies?.map((item: INewsItem, index: number) => {
                    const isLastItem = index === politicies.length - 1;
                    return <Content565 key={index} {...item} noBorder={isLastItem} />;
                  })}
                  <div className="flex jc-center">
                    <ShowListBtn
                      addList={() => {
                        navigate('/newsTopic/10');
                      }}
                    />
                  </div>
                  <div className="line"></div>
                </div>
              </div>

              <div className="topic-esg">
                <TopicContent contentText={'ESG'} type="esg" mainImg={esgesMainImg} />
                <div className="topic-container flex fd-col">
                  {esges?.map((item: INewsItem, index: number) => {
                    const isLastItem = index === esges.length - 1;
                    return <Content565 key={index} {...item} noBorder={isLastItem} />;
                  })}
                  <div className="flex jc-center">
                    <ShowListBtn
                      addList={() => {
                        navigate('/newsTopic/9');
                      }}
                    />
                  </div>
                  <div className="line"></div>
                </div>
              </div>

              <div className="topic-culture">
                <TopicContent contentText={'CULTURES'} type="culture" mainImg={culturesMainImg} />
                <div className="topic-container flex fd-col">
                  {cultures?.map((item: INewsItem, index: number) => {
                    const isLastItem = index === cultures.length - 1;
                    return <Content565 key={index} {...item} noBorder={isLastItem} />;
                  })}
                  <div className="flex jc-center">
                    <ShowListBtn
                      addList={() => {
                        navigate('/newsTopic/2');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </NewsTopicLayout>
      </div>
    </div>
  );
};
//
export default Home;
